/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasOperation } from '../../models/OasOperation';
import { OasParameter } from '../../models/OasParameter';
import { OasPathItem } from '../../models/OasPathItem';

/**
 * Constructor.
 * @param {string} path
 * @class
 * @extends OasPathItem
 * @author eric.wittmann@gmail.com
 */
export class Oas20PathItem extends OasPathItem {
    public constructor(path : string) {
        super(path);
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasPathItem#createOperation(java.lang.String)
     * @param {string} method
     * @return {OasOperation}
     */
    public createOperation(method : string) : OasOperation {
        let rval : OasOperation = new Oas20Operation(method);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasPathItem#createParameter()
     * @return {OasParameter}
     */
    public createParameter() : OasParameter {
        let rval : OasParameter = new Oas20Parameter();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }
}
Oas20PathItem["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20PathItem";
Oas20PathItem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.models.IOasParameterParent"];





import { Oas20Parameter } from './Oas20Parameter';


import { Oas20Operation } from './Oas20Operation';

